export const apiConstants = {
    GET_USERS: '/getusers',
    GET_DASHBOARD: '/dashboard',
    CHK_LOGIN: '/login',
    GET_PROFILE: '/profile',
    GET_SETTINGS: '/settings',
    UPDATE_PASSWORD: '/changepassword',
    UPDATE_USER_STATUS: '/updateuserstatus',
    GET_USERS_DETAILS: '/getuserdetail',
    SET_DEFAULT_ADDRESS: '/set-default-address',

    //-- we are using same api, might be update in future
    UPDATE_USER_DATA: '/updateadminprofile',
    UPDATE_ADMIN_PROFILE: '/updateadminprofile',

    //-- Notices
    GET_NOTICES: '/getnotices',
    ADD_UPDATE_NOTICE_DATA: '/updatenoticedetail',
    DELETE_NOTICE: '/deletenotice',

    //-- Advertisments
    GET_ADVERTISMENTS: '/getadvertisments',
    ADD_UPDATE_ADVERTISMENT_DATA: '/updateadvertismentdetail',
    DELETE_ADVERTISMENT: '/deleteadvertisment',

    //-- Notifications
    GET_NOTIFICATIONS: '/getnotifications',
    ADD_UPDATE_NOTIFICATION_DATA: '/updatenotificationdetail',
    DELETE_NOTIFICATION: '/deletenotification',
    UPDATE_NOTIFICATION_STATUS: '/updatenotificationstatus',

    ADMIN_PROFILE: '/admin/adminProfile',
    ADMIN_LOGIN: '/admin/login',
    CHANGE_ADMIN_PASSWORD: '/admin/change-admin-password',
    GET_ALL_USERS: '/admin/getusers',
    GET_SEARCH_DATA: '/admin/search-users',
    GET_ALL_USERS_COUNT: '/admin/user-stats',
    GET_SHOPKEEEPR_COUNTS: '/admin/shopkeeper-counts',
    UPLOAD_IMAGE: '/admin/updateprofile',
    ACTIVE_ACCOUNT: '/admin/activeaccount',
    GET_PENDING_USERS: '/admin/getpendinguser',
    GET_COMMISSION_SETTING: '/admin/fair-setup',
    RECOVER_PASSWORD: '/admin/forget-password',
    ADD_COUPON: '/admin/add-coupon',
    GET_COUPOUN: '/admin/get-coupon',
    GET_ACTIVE_COUPOUN: '/admin/get-active-coupon',
    SEARCH_COUPOUN: '/admin/search-coupon',
    EDIT_COUPON: '/admin/edit-coupon',
    DELETE_COUPON: '/admin/delete-coupon',
    GET_OUTLETS: '/outlet/getoutlets',


    //-- shop api
    SAVE_SHOP_LOGO: '/shop/save-logo',
    SAVE_SHOP_AND_SHOPKEEPER: '/shop/save-shop-and-shopkeeper',
    UPDATE_SHOP_AND_SHOPKEEPER: '/shop/update-shop-and-shopkeeper',
    GET_SHOP_AND_SHOPKEEPER: '/shop/get-shop-and-shopkeeper',
    FIND_SHOP_AND_SHOPKEEPER: '/shop/find-shop-and-shopkeeper',
    GET_SHOPKEEPER: '/shop/get-shopkeeper',

    // -- category api
    SAVE_CATEGORY: '/category/save-category',
    SAVE_CATEGORY_LOGO: '/category/save-category-logo',
    GET_CATEGORIES: '/category/get-categories',
    GET_ALL_ACTIVE_CATEGORIES_FOR_ADMIN: '/category/get-active-categories-for-admin',
    GET_ALL_ACTIVE_CATEGORIES: '/category/get-active-categories',
    GET_ALL_CATEGORIES_SUB_CATEGORIES: '/category/get-categories-subcategories',
    GET_ALL_SUB_CATEGORIES_BY_ID: '/category/get-subcategories-by-id',
    GET_ALL_SUB_CATEGORIES_BY_ID_FOR_ADMIN: '/category/get-subcategories-by-id-for-admin',
    FIND_CATEGORIES: '/category/find-category',
    GET_CATEGORY_BY_ID: '/category/get-category',
    EDIT_CATEGORY: '/category/edit-category',
    DELETE_CATEGORY: '/category/delete-category',


    //product page api
    SAVE_PRODUCT: '/product/save-product',
    SAVE_PRODUCT_MAIN_IMAGE: '/product/save-product-main-image',
    SAVE_PRODUCT_IMAGE_GALLERY: '/product/save-product-image-gallery',
    GET_PRODUCT_FOR_SHOPKEEPER: '/product/get-product-for-shopkeeper',
    GET_SINGLE_PRODUCT_FOR_SHOPKEEPER: '/product/get-single-product-for-shopkeeper',
    UPDATE_PRODUCT_BY_SHOPKEEPER: '/product/update-product-by-shopkeeper',
    SEARCH_PRODUCT_BY_KEYWORD_FOR_SHOPKEEPER: '/product/shopkeeper-search-product',
    DELETE_PRODUCT_BY_SHOPKEEPER: '/product/shopkeeper-delete-product',
    COPY_PRODUCT: '/product/copy-product',

    GET_PRODUCT_FOR_SHOPKEEPER_BY_ADMIN: '/product/get-product-of-shopkeeper-by-admin',
    SEARCH_PRODUCT_BY_KEYWORD_BY_ADMIN: '/product/admin-search-product-by-shop-id',

    // tax settings
    SAVE_TAX_SETTINGS: '/tax/save-tax-settings',
    GET_ALL_TAX_SETTINGS: '/tax/get-all-tax-settings',
    SEARCH_TAX_SETTINGS: '/tax/search-tax-settings',
    EDIT_TAX_SETTINGS: '/tax/edit-tax-settings',
    DELETE_TAX_SETTINGS: '/tax/delete-tax-settings',

    //DISCOUT API'S
    SAVE_DISCOUNT: '/discount/save-discounts',
    GET_DISCOUNT: '/discount/get-discounts',
    GET_ACTIVE_DISCOUNT: '/discount/get-active-discounts',
    SEARCH_DISCOUNT: '/discount/search-discounts',
    EDIT_DISCOUNT: '/discount/edit-discounts',
    DELETE_DISCOUNT: '/discount/delete-discounts',

    // tags api
    SAVE_TAG: '/tag/save-tags',
    GET_TAGS_LIST: '/tag/get-all-tags',
    DELETE_TAG: '/tag/delete-tag',
    GET_ACTIVE_TAGS: '/tag/get-all-active-tags',
    SEARCH_TAGS: '/tag/search-tags',

    // trending api
    GET_TRENDING_LIST: '/trending/get-all-trendings',
    DELETE_TRENDING: '/trending/delete-trending',

    //-- Payment Types
    GET_PAYMENT_TYPES: '/payment_types/get-all-payment-types',
    UPDATE_PAYMENT_TYPE_STATUS: '/payment_types/update-status',

    //-- Settings
    UPDATE_GENERAL_SETTINGS: '/general_settings/update-general-setting',
    GET_GENERAL_SETTING: '/general_settings/get-general-settings',

    //-- Notifications
    GET_NOTICATIONS: '/notifications/get-all-notifications',
    ADD_NOTICATIONS: '/notifications/add-notifications',
    SENT_PUSH_NOTIFICATIONS: '/notifications/sent-push-notifications',
    DELETE_NOTIFICATIONS: '/notifications/delete-notifications',
    GET_USERS_NOTIFICATIONS: '/notifications/get-users-notifications',
    GET_USERS_NOTIFICATIONS_FOR_BELL: '/notifications/get-users-notifications-bell',
    SEND_BELL_NOTIFICATIONS: '/notifications/sent-notifications',
    SEND_EMAIL_NOTIFICATIONS: '/notifications/email-notifications',

    //-- Banners
    GET_BANNERS: '/banners/get-all-banners',
    SAVE_BANNERS: '/banners/save-banner',
    SAVE_BANNER_IMAGE: '/banners/save-banner-image',
    DELETE_BANNER: '/banners/delete-banners',
    GET_PRODUCT_ATTRIBUTES: '/product-attribute/get-product-attributes',

    //-- IDeas
    GET_IDEAS: '/ideas/get-all-ideas',
    SAVE_IDEAS: '/ideas/save-idea',
    SAVE_IDEA_IMAGE: '/ideas/save-idea-image',
    DELETE_IDEA: '/ideas/delete-ideas',


    //-- Contest
    GET_CONTESTS: '/contests/get-all-contests',
    SAVE_CONTESTS: '/contests/save-contest',
    SAVE_CONTEST_IMAGE: '/contests/save-contest-image',
    DELETE_CONTEST: '/contests/delete-contests',

    //-- ORders
    GET_ALL_ORDERS: '/order/get-all-orders',
    GET_ORDER_DETAILS: '/order/get-order-details',
    MARK_ORDER_PAID: '/order/mark-order-paid',
    MARK_ORDER_ACCEPTED: '/order/mark-order-accepted',
    MARK_ORDER_REJECTED: '/order/mark-order-rejected',
    MARK_ORDER_PREPAIRED: '/order/mark-order-prepared',
    GET_USER_ACTIVE_ORDER: '/order/get-current-orders',
    USER_ACCOUNT_ACTIVATION: '/activate-account',
    STRIPE_AUTHORIZE_ACCOUNT: '/stripe-account-authorise',
    ORDER_COMPLETE: '/order/mark-order-completed',
    USER_PAYMENT_HISTORY: '/get-customer-payment-history',
    GET_EARNING_COUNT: '/admin/calculate-monthly-earnings',
    SEARCH_ORDER: '/order/search-order',
    ASSIGN_DELIVERY_BOY: '/order/assign-delivery-boy',
    PICKED_UP_BY_DELIVERY_BOY: '/order/picked_up_by_delivery_boy',
    ORDER_COMPLETED_BY_SHOPKEEPER: '/order/order-completed-by-shopkeeper',
    GET_SHOPKEEPER_CURRENT_ORDERS: '/order/get-shopkeeper-current-orders',
    CANCELATION_ORDER_ACCEPTED_BY_SHOPKEEPER: '/order/cancelation-order-accepted-by-shopkeeper',
    PRODUCT_RECEIEVED_AFTER_ORDER_REJECT_BY_CUSTOMER: '/order/product-received-after-order-rejected-by-customer',

    //-- school
    GET_SCHOOL: '/school/get-school',
    GET_SCHOOL_BY_ID: '/school/get-school-by-id',
    SAVE_SCHOOL: '/school/add-school',
    UPDATE_SCHOOL: '/school/update-school',
    DELETE_SCHOOL: '/school/delete-school',

    //-- participant
    GET_PARTICIPANT: '/participant/get-all-participant',
    GET_PARTICIPANT_BY_ID: '/participant/get-participant-by-id',
    SAVE_PARTICIPANT: '/participant/add-new-participant',
    UPDATE_PARTICIPANT: '/participant/update-participant',
    DELETE_PARTICIPANT: '/participant/delete-participant',
    SAVE_PARTICIPANT_IMAGE: '/participant/save-participant-image',


};
